<template>
    <component
        :is="layout === 'tr' ? 'tr' : 'v-row'"
        no-gutters
        :class="{
            'pa-0': layout !== 'tr',
            'ma-0': layout !== 'tr',
            'd-flex flex-column justify-center align-center': layout !== 'tr',
        }"
        :style="{ height: layout !== 'tr' ? '100%' : '' }"
    >
        <v-col
            v-if="layout === 'vertical'"
            class="px-1 my-2 w-100"
            style="background-color: white; border-radius: 5px"
        >
            <v-row class="pa-0 ma-0 border-e-sm" no-gutters>
                <v-col cols="12" class="d-flex justify-center">
                    <small class="d-inline-block">Dossier de révision</small>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                    <v-progress-circular
                        :rotate="-90"
                        :size="60"
                        :width="8"
                        :color="getProgressColor(props.item.id)"
                        @click="onAvatarClicked('auditReport')"
                        style="cursor: pointer"
                        :model-value="getAuditReportStatusPercent(props.item.id)"
                    >
                        {{ getAuditReportStatus(props.item.id) }}
                    </v-progress-circular>
                </v-col>
            </v-row>
            <!-- <v-divider class="my-1" /> -->
            <v-row class="pa-0 ma-0" no-gutters>
                <v-col cols="12" class="d-flex justify-center">
                    <small class="d-inline-block">Liasse</small>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                    <v-avatar
                        :tile="true"
                        size="28"
                        :color="getBundleColor(props.item)"
                        @click="onLAvatarClicked"
                        style="cursor: pointer"
                    >
                        <span class="text-white font-weight-bold">L</span>
                    </v-avatar>
                </v-col>
            </v-row>
        </v-col>
        <v-row
            no-gutters
            v-else-if="layout === 'horizontal'"
            class="px-1 my-2 w-100"
            style="background-color: white; border-radius: 5px; height: auto"
        >
            <v-col cols="7" class="pa-0 ma-0" style="border-right: 0.8px solid rgba(0, 0, 0, 0.12)">
                <v-row no-gutters cols="12" class="d-flex justify-center align-center">
                    <small class="d-inline-block">Dossier de révision</small>
                </v-row>
                <v-row no-gutters cols="12" class="d-flex justify-center align-center">
                    <v-progress-circular
                        :rotate="-90"
                        :size="55"
                        :width="6"
                        :color="getProgressColor(props.item.id)"
                        @click="onAvatarClicked('auditReport')"
                        style="cursor: pointer"
                        :model-value="getAuditReportStatusPercent(props.item.id)"
                    >
                        {{ getAuditReportStatus(props.item.id) }}
                    </v-progress-circular>
                </v-row>
            </v-col>

            <v-col cols="5" class="pa-0 ma-0 d-flex align-center" no-gutters>
                <div class="d-flex mx-auto flex-column">
                    <v-row no-gutters cols="12">
                        <small class="d-inline-block">Liasse</small>
                    </v-row>
                    <v-row no-gutters cols="12">
                        <v-avatar
                            :tile="true"
                            size="28"
                            :color="getBundleColor(props.item)"
                            @click="onLAvatarClicked"
                            style="cursor: pointer"
                        >
                            <span class="text-white font-weight-bold">L</span>
                        </v-avatar>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <template v-else>
            <td v-for="(header, index) of headers" :key="index" style="padding: 0px">
                <!-- {{ header }} -->
                <v-row
                    no-gutters
                    v-if="index === 0 && !hideName"
                    @click="onNameClicked(props.item)"
                    style="cursor: pointer"
                >
                    <v-col cols="12" class="font-weight-medium pl-1">
                        {{ props.item.name }}
                    </v-col>
                </v-row>
                <!-- When the name is hidden, colums are shifted left by 1 -->
                <v-row
                    no-gutters
                    v-else-if="index === (hideName ? 0 : 1)"
                    class="rounded d-flex justify-center"
                    style="overflow: hidden; cursor: pointer"
                >
                    <v-col cols="1" />
                    <v-col cols="10" class="d-flex justify-center align-center">
                        <v-progress-linear
                            data-cy="AccountingClientMonitoring-audit"
                            readonly
                            rounded
                            :color="getProgressColor(props.item.id)"
                            height="15"
                            v-if="!loading"
                            @click="onAvatarClicked('auditReport')"
                            :model-value="getAuditReportStatusPercent(props.item.id)"
                        >
                            <strong style="padding-top: 1px">{{
                                getAuditReportStatus(props.item.id)
                            }}</strong>
                        </v-progress-linear>
                    </v-col>
                    <v-col cols="1" />
                </v-row>
                <v-row
                    no-gutters
                    v-else
                    class="rounded d-flex justify-center"
                    style="overflow: hidden; cursor: pointer"
                >
                    <v-col cols="4" />
                    <v-col cols="4" class="ma-0 d-flex justify-center">
                        <v-avatar
                            :tile="true"
                            :color="getBundleColor(props.item)"
                            size="25"
                            class="pa-0 ma-0 avatarHover"
                            @click="onLAvatarClicked"
                            style="cursor: pointer"
                            data-cy="AccountingClientMonitoring-case"
                            v-tooltip.bottom="getBundleStatus(props.item)"
                        >
                            <span class="text-white font-weight-bold">L</span>
                        </v-avatar>
                    </v-col>
                    <v-col cols="4" />
                </v-row>
            </td>
        </template>
    </component>
</template>

<script lang="ts">
import { setCurrentCompany } from "@/services/userServices";
import colors from "vuetify/lib/util/colors";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["name-clicked", "avatar-clicked"],
})
export class AccountingClientMonitoringClosureRow extends Vue {
    @Prop({ default: () => [] }) headers: Array<any>;
    @Prop({ default: () => ({}) }) props: { [key: string]: any };
    // @Prop({default: null}) itemValue: any
    @Prop({ default: false }) hideName: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: null }) auditReportMonitoring: any;
    @Prop({ default: false }) useVerticalLayout: boolean; // Data will be displayed in a vertical card-like component
    @Prop({ default: "tr" }) layout: "tr" | "vertical" | "horizontal";

    get company() {
        return this.props.item;
    }

    getProgressColor(id) {
        if (
            this.auditReportMonitoring[id]?.count &&
            (this.auditReportMonitoring[id]?.doneCount !== null ||
                this.auditReportMonitoring[id]?.doneCount !== undefined)
        ) {
            if (this.auditReportMonitoring[id]?.doneCount === 0) {
                return this.red;
            }
            if (
                this.auditReportMonitoring[id]?.doneCount === this.auditReportMonitoring[id]?.count
            ) {
                return this.green;
            } else {
                return "primary";
            }
        } else {
            return this.grey;
        }
    }

    getBundleColor(company) {
        if (!this.auditReportMonitoring[company.id]?.bundle) {
            return this.grey;
        }

        if (
            this.auditReportMonitoring &&
            this.auditReportMonitoring[company.id] &&
            this.auditReportMonitoring[company.id].bundle
        ) {
            switch (this.auditReportMonitoring[company.id].bundle.status) {
                case "EDITION":
                    return this.orange;
                case "SENT":
                    switch (this.auditReportMonitoring[company.id].bundle.mtaeStatus) {
                        case "Déclaration acceptée":
                            return this.green;
                        default:
                            return this.blue;
                    }
                case "ERROR":
                    return this.red;
                default:
                    return this.grey;
            }
        }
    }

    getBundleStatus(company) {
        if (!this.auditReportMonitoring[company.id]?.bundle) {
            return "Aucune liasse";
        }

        if (
            this.auditReportMonitoring &&
            this.auditReportMonitoring[company.id] &&
            this.auditReportMonitoring[company.id].bundle
        ) {
            switch (this.auditReportMonitoring[company.id].bundle.status) {
                case "EDITION":
                    return "Liasse en cours d'édition";
                case "SENT":
                    switch (this.auditReportMonitoring[company.id].bundle.mtaeStatus) {
                        case "Déclaration acceptée":
                            return "Liasse acceptée par l'administration fiscale";
                        case "OK":
                            return "Liasse envoyée à l'administration fiscale";
                        default:
                            return this.auditReportMonitoring[company.id].bundle.mtaeStatus;
                    }
                case "ERROR":
                    switch (this.auditReportMonitoring[company.id].bundle.mtaeStatus) {
                        case "Déclaration refusée":
                            return "Liasse refusée par l'administration fiscale";
                        default:
                            return "Erreur";
                    }
                default:
                    return "Inconnu";
            }
        }
    }

    getAuditReportStatusPercent(id) {
        if (
            this.auditReportMonitoring[id]?.count &&
            (this.auditReportMonitoring[id]?.doneCount !== null ||
                this.auditReportMonitoring[id]?.doneCount !== undefined)
        ) {
            return (
                (this.auditReportMonitoring[id].doneCount / this.auditReportMonitoring[id].count) *
                100
            );
        } else {
            return 0;
        }
    }

    getAuditReportStatus(id) {
        if (
            this.auditReportMonitoring[id]?.count &&
            (this.auditReportMonitoring[id]?.doneCount !== null ||
                this.auditReportMonitoring[id]?.doneCount !== undefined)
        ) {
            return (
                this.auditReportMonitoring[id].doneCount +
                "/" +
                this.auditReportMonitoring[id].count
            );
        } else {
            // return "Pas d'exercice comptable pour la période recherchée"
            return this.layout === "tr"
                ? "Pas d'exercice comptable pour la période recherchée"
                : "N/A";
        }
    }

    // getDeclarationInfos(company, tax, date) {
    //     if (
    //         this.selectedView === "taxes" &&
    //         this.taxesMonitoring &&
    //         this.taxesMonitoring[company.id] &&
    //         this.taxesMonitoring[company.id][tax] &&
    //         this.taxesMonitoring[company.id][tax][date]
    //     ) {
    //         return `${this.taxesDico[this.taxesMonitoring[company.id][tax][date].cerfaNumber]} - ${moment(date).format("MM/YYYY")} - ${this.taxesMonitoring[company.id][tax][date].status === "SENT" ? "Envoyée" : "Édition"}`

    //     } else {
    //         if (tax === "IS") {
    //             if (this.taxesSchedule[tax].includes(date.substring(5, 7))) {
    //                 return `Déclaration d'IS du 15/${moment(date).format("MM/YYYY")} manquante`
    //             } else {
    //                 return `Pas de déclaration d'IS attendue au mois de ${moment(date).format("MM/YYYY")}`
    //             }
    //         } else if (tax === "TVA") {
    //             if ((company.vatSystem === "Quartely" && this.taxesSchedule["TVAQ"].includes(date.substring(5, 7))) || (company.vatSystem === "Simplified" && this.taxesSchedule["TVAS"].includes(date.substring(5, 7))) || company.vatSystem === "Normal") {
    //                 if (company.vatDeclarationDay) {
    //                     return `Déclaration de TVA du ${company.vatDeclarationDay}/${moment(date).format("MM/YYYY")} manquante`
    //                 } else {
    //                     return `Déclaration de TVA du mois de ${moment(date).format("MM/YYYY")} manquante`
    //                 }
    //             } else {
    //                 return `Pas de déclaration de TVA attendue au mois de ${moment(date).format("MM/YYYY")}`
    //             }
    //         } else {
    //             if (this.taxesSchedule[tax].includes(date.substring(5, 7))) {
    //                 return `Déclaration de ${tax} du 15/${moment(date).format("MM/YYYY")} manquante`
    //             } else {
    //                 return `Pas de déclaration de ${tax} attendue au mois de ${moment(date).format("MM/YYYY")}`
    //             }
    //         }
    //     }
    // }

    get red() {
        return colors.red.accent1;
    }

    get green() {
        return "green";
    }

    get blue() {
        return colors.blue.lighten1;
    }

    get orange() {
        return colors.orange.lighten1;
    }

    get white() {
        return colors.grey.lighten4;
    }

    get grey() {
        return colors.grey.lighten1;
    }

    // taxesSelectedContain(tax) {
    //     return !!this.taxesSelected.filter((x) => x === tax).length;
    // }

    async onNameClicked(item) {
        await this.openDashboard();
        this.$emit("name-clicked", item);
    }

    onLAvatarClicked() {
        this.onAvatarClicked("taxFormsTab", { selectedWindow: "taxDeclarations" });
    }

    onAvatarClicked(path, params = {}) {
        this.getClick(path, params);
        this.$emit("avatar-clicked", path);
        // this.actionDialog = true
    }

    getClick(path: string, params = {}) {
        if (path.length) {
            this.$router.push({ name: path, params: params });
        }
    }

    async openDashboard() {
        await setCurrentCompany(this.$apollo, this.$store, this.company, undefined, true);
        // this.$router.push({ name: "dashboard" });
        this.$router.push({ name: "companyStatusBoard" });
    }

    // onDialogIgnoreClicked() {
    //     this.$emit("dialog-ignore-clicked")
    //     // this.actionDialog = false
    // }

    // onDialogRedirectClicked() {
    //     this.$emit("dialog-redirect-clicked")
    // }
}

export default toNative(AccountingClientMonitoringClosureRow);
</script>
<style scoped></style>
